function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "like",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,6.66666667 C11.7283386,6.34069761 11.4116432,6.05607212 11.0622505,5.81866726 C10.2901344,5.29403105 9.35833893,5 8.4,5 C5.93600006,5 4,6.97820187 4,9.49591279 C4,10.3905042 4.2045939,11.2400115 4.55506306,12.0482024 C5.64208183,14.5571566 8.13260803,16.6744153 10.2763977,18.4969044 C10.8935936,19.0215969 11.4820496,19.5218579 12,20 C12.5179504,19.5218579 13.1064064,19.0215969 13.7236023,18.4969044 C15.8673546,16.6744479 18.3578308,14.5572321 19.4448792,12.0483359 C19.7953842,11.2401052 20,10.3905531 20,9.49591279 C20,6.97820187 18.0639999,5 15.6,5 C14.6416611,5 13.7098656,5.294031 12.9377495,5.81866721 C12.5883568,6.05607212 12.2716614,6.34069761 12,6.66666667 C11.8188924,6.44935396 11.8188924,6.44935396 12,6.66666667 Z",
  id: "basic-/-heart_outline",
  fill: "#C2C2C2"
}));

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "like") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.24d24b51.svg";
export { ForwardRef as ReactComponent };